// =====================================================================
// CardModal (Quadros Q1 + Q2 + PRO / S59-S60; redesign Trello-like S71) — detalhe do card.
// REDESIGN S71: content-first como o Trello — capa renderizada no topo, chips do
// que está APLICADO (etiquetas/membros/prioridade/prazo), uma BARRA DE AÇÕES
// (Membros · Etiquetas · Datas · Prioridade · Capa · Anexo) que abre cada editor
// num Popover sob clique (em vez de todos os formulários expostos). Descrição,
// checklist (barra), anexos (miniatura), vínculos CRM e comentários abaixo.
// Toda a LÓGICA (salvar/duplicar/arquivar/anexos/vínculos/comentários) é a mesma.
// =====================================================================
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem,
  Box, Typography, IconButton, Checkbox, CircularProgress, Divider, Paper, LinearProgress, Popover
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import ArchiveIcon from "@material-ui/icons/Archive";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import GetAppIcon from "@material-ui/icons/GetApp";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import LabelIcon from "@material-ui/icons/Label";
import EventIcon from "@material-ui/icons/Event";
import FlagIcon from "@material-ui/icons/Flag";
import PhotoIcon from "@material-ui/icons/Photo";
import SubjectIcon from "@material-ui/icons/Subject";
import ScheduleIcon from "@material-ui/icons/Schedule";
import DoneIcon from "@material-ui/icons/Done";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import AddIcon from "@material-ui/icons/Add";
import AttachmentThumb from "./AttachmentThumb";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import {
  updateCard, removeCard, cardActivity, addCardComment, boardErrorMessage, LABEL_COLORS,
  getCardLinks, setCardLinks, searchCrmLinks, LINK_KINDS, linkKindMeta,
  duplicateCard, archiveCard, listCardAttachments, uploadCardAttachment, removeCardAttachment,
  PRIORITIES, checklistProgress, priorityMeta, dueMeta, fmtDateBR
} from "../../services/boardService";

const initialsOf = (name) =>
  String(name || "?").trim().split(/\s+/).slice(0, 2).map((s) => s[0] || "").join("").toUpperCase() || "?";

const CardModal = ({ open, card, users, boardLabels, onClose, onChanged, onLinksChanged }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [done, setDone] = useState(false);
  const [assignedUserId, setAssignedUserId] = useState("");
  const [members, setMembers] = useState([]);
  const [priority, setPriority] = useState("");
  const [coverColor, setCoverColor] = useState("");
  const [labels, setLabels] = useState([]);
  const [checklist, setChecklist] = useState([]);
  const [newCheck, setNewCheck] = useState("");
  const [activity, setActivity] = useState([]);
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);
  // barra de ações → popover (qual editor está aberto)
  const [pop, setPop] = useState({ anchor: null, kind: "" });
  const [showLinkAdd, setShowLinkAdd] = useState(false);
  // Vínculos CRM (Q2)
  const [links, setLinks] = useState({});
  const [linksLoading, setLinksLoading] = useState(false);
  const [addKind, setAddKind] = useState("patient");
  const [term, setTerm] = useState("");
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  // Anexos (PRO)
  const [attachments, setAttachments] = useState([]);
  const [uploading, setUploading] = useState(false);
  const searchTimer = useRef(null);
  const fileRef = useRef(null);
  const history = useHistory();

  const loadActivity = useCallback(async (id) => {
    try { const d = await cardActivity(id); setActivity((d && d.activity) || []); }
    catch { setActivity([]); }
  }, []);

  const loadLinks = useCallback(async (id) => {
    setLinksLoading(true);
    try { const d = await getCardLinks(id); setLinks((d && d.links) || {}); }
    catch { setLinks({}); }
    finally { setLinksLoading(false); }
  }, []);

  const loadAttachments = useCallback(async (id) => {
    try { const d = await listCardAttachments(id); setAttachments((d && d.attachments) || []); }
    catch { setAttachments([]); }
  }, []);

  useEffect(() => {
    if (open && card) {
      setTitle(card.title || "");
      setDescription(card.description || "");
      setDueDate(card.dueDate ? String(card.dueDate).slice(0, 10) : "");
      setStartDate(card.startDate ? String(card.startDate).slice(0, 10) : "");
      setDone(!!card.done);
      setAssignedUserId(card.assignedUserId ? String(card.assignedUserId) : "");
      setMembers(Array.isArray(card.members) ? card.members.map(Number) : []);
      setPriority(card.priority || "");
      setCoverColor(card.coverColor || "");
      setLabels(Array.isArray(card.labels) ? card.labels : []);
      setChecklist(Array.isArray(card.checklist) ? card.checklist : []);
      setComment(""); setNewCheck("");
      setTerm(""); setResults([]); setAddKind("patient");
      setPop({ anchor: null, kind: "" });
      setShowLinkAdd(false);
      loadActivity(card.id);
      loadLinks(card.id);
      loadAttachments(card.id);
    }
  }, [open, card, loadActivity, loadLinks, loadAttachments]);

  useEffect(() => {
    if (!open) return undefined;
    if (searchTimer.current) clearTimeout(searchTimer.current);
    const q = term.trim();
    if (!q) { setResults([]); setSearching(false); return undefined; }
    setSearching(true);
    searchTimer.current = setTimeout(async () => {
      try { const d = await searchCrmLinks(addKind, q); setResults((d && d.items) || []); }
      catch { setResults([]); }
      finally { setSearching(false); }
    }, 350);
    return () => { if (searchTimer.current) clearTimeout(searchTimer.current); };
  }, [term, addKind, open]);

  if (!card) return null;

  const userName = (id) => { const u = users.find((x) => Number(x.id) === Number(id)); return u ? u.name : `#${id}`; };

  // etiquetas: usa a paleta NOMEADA do quadro se houver; senão cores padrão
  const palette = (boardLabels && boardLabels.length)
    ? boardLabels
    : LABEL_COLORS.map((c) => ({ color: c }));
  const isLabelOn = (pl) => labels.some((l) => (pl.id ? l.id === pl.id : l.color === pl.color && !l.id));
  const toggleLabel = (pl) =>
    setLabels((prev) => (isLabelOn(pl)
      ? prev.filter((l) => (pl.id ? l.id !== pl.id : !(l.color === pl.color && !l.id)))
      : [...prev, pl.id ? { id: pl.id, name: pl.name, color: pl.color } : { color: pl.color }]));

  const addCheck = () => { const t = newCheck.trim(); if (!t) return; setChecklist((p) => [...p, { text: t, done: false }]); setNewCheck(""); };
  const toggleCheck = (i) => setChecklist((p) => p.map((c, idx) => (idx === i ? { ...c, done: !c.done } : c)));
  const removeCheck = (i) => setChecklist((p) => p.filter((_, idx) => idx !== i));
  const prog = checklistProgress(checklist);

  const openPop = (e, kind) => setPop({ anchor: e.currentTarget, kind });
  const closePop = () => setPop({ anchor: null, kind: "" });

  const handleSave = async () => {
    if (!title.trim()) { toast.error("Dê um título ao card."); return; }
    setSaving(true);
    try {
      await updateCard(card.id, {
        title, description, dueDate: dueDate || null, startDate: startDate || null, done,
        assignedUserId: assignedUserId || null, members, priority: priority || null,
        coverColor: coverColor || null, labels, checklist
      });
      toast.success("Card salvo.");
      onChanged && onChanged();
    } catch (e) { toast.error(boardErrorMessage(e)); } finally { setSaving(false); }
  };

  const handleDelete = async () => {
    if (!window.confirm("Excluir este card?")) return;
    try { await removeCard(card.id); onChanged && onChanged(); } catch (e) { toast.error(boardErrorMessage(e)); }
  };
  const handleDuplicate = async () => {
    try { await duplicateCard(card.id); toast.success("Card duplicado."); onChanged && onChanged(); }
    catch (e) { toast.error(boardErrorMessage(e)); }
  };
  const handleArchive = async () => {
    if (!window.confirm("Arquivar este card? (some do quadro, sem apagar)")) return;
    try { await archiveCard(card.id); toast.success("Card arquivado."); onChanged && onChanged(); }
    catch (e) { toast.error(boardErrorMessage(e)); }
  };

  const handleComment = async () => {
    const t = comment.trim(); if (!t) return;
    try { await addCardComment(card.id, t); setComment(""); loadActivity(card.id); }
    catch (e) { toast.error(boardErrorMessage(e)); }
  };

  // ---- Vínculos CRM ----
  const attachLink = async (kind, id) => {
    try {
      const d = await setCardLinks(card.id, { [kind]: id });
      setLinks((d && d.links) || {});
      setTerm(""); setResults([]);
      onLinksChanged && onLinksChanged();
    } catch (e) { toast.error(boardErrorMessage(e)); }
  };
  const detachLink = async (kind) => {
    try {
      const d = await setCardLinks(card.id, { [kind]: null });
      setLinks((d && d.links) || {});
      onLinksChanged && onLinksChanged();
    } catch (e) { toast.error(boardErrorMessage(e)); }
  };
  const openRoute = (route) => { if (route) { onClose && onClose(); history.push(route); } };

  // ---- Anexos ----
  const handleUpload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (fileRef.current) fileRef.current.value = "";
    if (!file) return;
    setUploading(true);
    try { await uploadCardAttachment(card.id, file); loadAttachments(card.id); onLinksChanged && onLinksChanged(); }
    catch (err) { toast.error(boardErrorMessage(err)); }
    finally { setUploading(false); }
  };
  const handleDownload = async (att) => {
    try {
      const resp = await api.get(`/board-attachments/${att.id}/download`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([resp.data], { type: att.mime || "application/octet-stream" }));
      const a = document.createElement("a");
      a.href = url; a.download = att.fileName || "arquivo"; document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch { toast.error("Não foi possível baixar o anexo."); }
  };
  const handlePreview = async (att) => {
    try {
      const resp = await api.get(`/board-attachments/${att.id}/download`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([resp.data], { type: att.mime || "application/octet-stream" }));
      const win = window.open(url, "_blank");
      if (!win) toast.info("Libere o pop-up pra abrir o anexo em nova aba.");
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } catch { toast.error("Não foi possível abrir o anexo."); }
  };
  const handleRemoveAttachment = async (att) => {
    if (!window.confirm(`Remover o anexo "${att.fileName}"?`)) return;
    try { await removeCardAttachment(att.id); loadAttachments(card.id); onLinksChanged && onLinksChanged(); }
    catch (e) { toast.error(boardErrorMessage(e)); }
  };

  const pm = priorityMeta(priority);
  const due = dueMeta(dueDate, done);
  const memberChips = members.filter((id) => String(id) !== String(assignedUserId));
  const hasMeta = labels.length > 0 || assignedUserId || memberChips.length > 0 || priority || dueDate || done;

  const Avatar = ({ name }) => (
    <span title={name} style={{ width: 26, height: 26, borderRadius: "50%", background: "#1565c0", color: "#fff",
      fontSize: 11, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>{initialsOf(name)}</span>
  );
  const sectionLabel = (Icon, text, right) => (
    <Box display="flex" alignItems="center" justifyContent="space-between" style={{ marginBottom: 4, marginTop: 14 }}>
      <Box display="flex" alignItems="center" style={{ gap: 6, color: "#607d8b" }}>
        <Icon style={{ fontSize: 18 }} /><Typography variant="subtitle2">{text}</Typography>
      </Box>
      {right || null}
    </Box>
  );

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth>
      {card.coverImageId
        ? <AttachmentThumb attachmentId={card.coverImageId} style={{ width: "100%", maxHeight: 170, objectFit: "cover", display: "block" }} />
        : coverColor ? <div style={{ height: 40, background: coverColor }} /> : null}
      <DialogTitle style={{ paddingBottom: 0 }}>
        <TextField value={title} onChange={(e) => setTitle(e.target.value)} fullWidth placeholder="Título do card"
          InputProps={{ style: { fontSize: 20, fontWeight: 500 } }} />
      </DialogTitle>
      <DialogContent dividers>
        {/* chips do que está APLICADO */}
        {hasMeta && (
          <Box display="flex" style={{ gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 12 }}>
            {labels.map((lb, i) => (lb.name
              ? <span key={i} style={{ fontSize: 11, padding: "2px 10px", borderRadius: 4, background: lb.color || "#90a4ae", color: "#fff" }}>{lb.name}</span>
              : <span key={i} title={lb.color} style={{ width: 32, height: 14, borderRadius: 4, background: lb.color || "#90a4ae", display: "inline-block" }} />))}
            {assignedUserId ? <Avatar name={userName(assignedUserId)} /> : null}
            {memberChips.map((id) => <Avatar key={id} name={userName(id)} />)}
            {priority ? <span style={{ fontSize: 12, color: pm.color, display: "inline-flex", alignItems: "center", gap: 3 }}><FlagIcon style={{ fontSize: 15 }} />{pm.label}</span> : null}
            {dueDate ? <span style={{ fontSize: 11, display: "inline-flex", alignItems: "center", gap: 3, padding: "2px 8px", borderRadius: 4,
              background: due ? due.color : "#eceff1", color: due ? "#fff" : "#546e7a" }}><ScheduleIcon style={{ fontSize: 13 }} />{fmtDateBR(dueDate)}</span> : null}
            {done ? <span style={{ fontSize: 12, color: "#2e7d32", display: "inline-flex", alignItems: "center", gap: 3 }}><DoneIcon style={{ fontSize: 15 }} />concluído</span> : null}
          </Box>
        )}

        {/* barra de ações */}
        <Box display="flex" style={{ gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
          <Button size="small" variant="outlined" startIcon={<PersonAddIcon />} onClick={(e) => openPop(e, "members")}>Membros</Button>
          <Button size="small" variant="outlined" startIcon={<LabelIcon />} onClick={(e) => openPop(e, "labels")}>Etiquetas</Button>
          <Button size="small" variant="outlined" startIcon={<EventIcon />} onClick={(e) => openPop(e, "dates")}>Datas</Button>
          <Button size="small" variant="outlined" startIcon={<FlagIcon />} onClick={(e) => openPop(e, "priority")}>Prioridade</Button>
          <Button size="small" variant="outlined" startIcon={<PhotoIcon />} onClick={(e) => openPop(e, "cover")}>Capa</Button>
          <Button size="small" variant="outlined" startIcon={uploading ? <CircularProgress size={14} /> : <AttachFileIcon />}
            onClick={() => fileRef.current && fileRef.current.click()} disabled={uploading}>Anexo</Button>
          <input ref={fileRef} type="file" style={{ display: "none" }} onChange={handleUpload} />
        </Box>

        <Popover open={!!pop.anchor} anchorEl={pop.anchor} onClose={closePop}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }} transformOrigin={{ vertical: "top", horizontal: "left" }}>
          <Box p={1.5} style={{ minWidth: 240, maxWidth: 320 }}>
            {pop.kind === "members" && (
              <>
                <TextField select label="Responsável" value={assignedUserId} onChange={(e) => setAssignedUserId(e.target.value)} fullWidth margin="dense">
                  <MenuItem value="">— ninguém —</MenuItem>
                  {users.map((u) => <MenuItem key={u.id} value={String(u.id)}>{u.name}</MenuItem>)}
                </TextField>
                <TextField select label="Membros" SelectProps={{ multiple: true, renderValue: (sel) => (sel || []).map(userName).join(", ") }}
                  value={members} onChange={(e) => setMembers(e.target.value)} fullWidth margin="dense">
                  {users.map((u) => <MenuItem key={u.id} value={Number(u.id)}>{u.name}</MenuItem>)}
                </TextField>
              </>
            )}
            {pop.kind === "labels" && (
              <Box display="flex" style={{ gap: 6, flexWrap: "wrap" }}>
                {palette.map((pl, i) => (
                  <div key={pl.id || pl.color || i} onClick={() => toggleLabel(pl)} title={pl.name || pl.color}
                    style={{ minWidth: 30, height: 26, padding: "0 8px", borderRadius: 4, background: pl.color, cursor: "pointer",
                      color: "#fff", fontSize: 11, display: "flex", alignItems: "center",
                      border: isLabelOn(pl) ? "2px solid #000" : "2px solid transparent" }}>
                    {pl.name || ""}
                  </div>
                ))}
              </Box>
            )}
            {pop.kind === "dates" && (
              <>
                <TextField type="date" label="Início" value={startDate} onChange={(e) => setStartDate(e.target.value)} InputLabelProps={{ shrink: true }} fullWidth margin="dense" />
                <TextField type="date" label="Prazo" value={dueDate} onChange={(e) => setDueDate(e.target.value)} InputLabelProps={{ shrink: true }} fullWidth margin="dense" />
                <Box display="flex" alignItems="center"><Checkbox checked={done} onChange={(e) => setDone(e.target.checked)} /><Typography variant="body2">Concluído</Typography></Box>
              </>
            )}
            {pop.kind === "priority" && (
              <TextField select label="Prioridade" value={priority} onChange={(e) => setPriority(e.target.value)} fullWidth margin="dense">
                {PRIORITIES.map((p) => <MenuItem key={p.value || "none"} value={p.value}>{p.label}</MenuItem>)}
              </TextField>
            )}
            {pop.kind === "cover" && (
              <Box display="flex" style={{ gap: 6, flexWrap: "wrap" }}>
                <div onClick={() => setCoverColor("")} title="Sem capa"
                  style={{ width: 28, height: 18, borderRadius: 4, background: "#fff", cursor: "pointer", border: !coverColor ? "2px solid #000" : "1px solid #ccc" }} />
                {LABEL_COLORS.map((c) => (
                  <div key={c} onClick={() => setCoverColor(c)} title={c}
                    style={{ width: 28, height: 18, borderRadius: 4, background: c, cursor: "pointer", border: coverColor === c ? "2px solid #000" : "2px solid transparent" }} />
                ))}
              </Box>
            )}
          </Box>
        </Popover>

        {sectionLabel(SubjectIcon, "Descrição")}
        <TextField value={description} onChange={(e) => setDescription(e.target.value)} fullWidth multiline rowsMax={40} margin="dense"
          placeholder="Adicione uma descrição mais detalhada..." />

        {sectionLabel(CheckBoxOutlinedIcon, "Checklist", prog.total > 0
          ? <Typography variant="caption" color="textSecondary">{prog.done}/{prog.total} ({prog.pct}%)</Typography> : null)}
        {prog.total > 0 && <LinearProgress variant="determinate" value={prog.pct} style={{ margin: "0 0 6px", borderRadius: 4, height: 6 }} />}
        {checklist.map((c, i) => (
          <Box key={i} display="flex" alignItems="center">
            <Checkbox size="small" checked={!!c.done} onChange={() => toggleCheck(i)} />
            <Typography variant="body2" style={{ flex: 1, textDecoration: c.done ? "line-through" : "none" }}>{c.text}</Typography>
            <IconButton size="small" onClick={() => removeCheck(i)}><DeleteIcon fontSize="small" /></IconButton>
          </Box>
        ))}
        <Box display="flex" style={{ gap: 6 }} mt={0.5}>
          <TextField size="small" placeholder="Novo item" value={newCheck} onChange={(e) => setNewCheck(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") addCheck(); }} fullWidth />
          <Button size="small" onClick={addCheck}>Add</Button>
        </Box>

        {sectionLabel(AttachFileIcon, "Anexos", (
          <Button size="small" startIcon={uploading ? <CircularProgress size={14} /> : <AttachFileIcon fontSize="small" />}
            onClick={() => fileRef.current && fileRef.current.click()} disabled={uploading}>Anexar</Button>
        ))}
        <Box>
          {attachments.length === 0 ? (
            <Typography variant="body2" color="textSecondary">Nenhum anexo.</Typography>
          ) : attachments.map((att) => (
            <Box key={att.id} display="flex" alignItems="center" style={{ gap: 4 }}>
              {att.mime && att.mime.indexOf("image/") === 0
                ? <AttachmentThumb attachmentId={att.id} onClick={() => handlePreview(att)} title="Abrir"
                    style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 4, cursor: "pointer" }} />
                : <AttachFileIcon fontSize="small" style={{ color: "#90a4ae" }} />}
              <Typography variant="body2" noWrap title="Abrir / pré-visualizar"
                style={{ flex: 1, minWidth: 0, cursor: "pointer", textDecoration: "underline" }}
                onClick={() => handlePreview(att)}>{att.fileName}</Typography>
              <IconButton size="small" title="Abrir em nova aba" onClick={() => handlePreview(att)}><OpenInNewIcon fontSize="small" /></IconButton>
              <IconButton size="small" title="Baixar" onClick={() => handleDownload(att)}><GetAppIcon fontSize="small" /></IconButton>
              <IconButton size="small" title="Remover" onClick={() => handleRemoveAttachment(att)}><DeleteIcon fontSize="small" /></IconButton>
            </Box>
          ))}
        </Box>

        {/* ---- Vínculos CRM (Q2) ---- */}
        <Divider style={{ margin: "14px 0 0" }} />
        {sectionLabel(OpenInNewIcon, "Vínculos CRM")}
        <Box mb={1}>
          {linksLoading ? (
            <CircularProgress size={16} />
          ) : LINK_KINDS.filter((k) => links[k.kind]).length === 0 ? (
            <Typography variant="body2" color="textSecondary">Sem vínculos.</Typography>
          ) : (
            LINK_KINDS.filter((k) => links[k.kind]).map((k) => {
              const it = links[k.kind];
              return (
                <Box key={k.kind} display="flex" alignItems="center" style={{ gap: 6, marginBottom: 4 }}>
                  <span title={k.label} style={{ fontSize: 16 }}>{k.icon}</span>
                  <Box style={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="body2" noWrap><b>{k.label}:</b> {it.label}</Typography>
                    {it.sub ? <Typography variant="caption" color="textSecondary" noWrap style={{ display: "block" }}>{it.sub}</Typography> : null}
                  </Box>
                  {it.route ? <Button size="small" onClick={() => openRoute(it.route)}>Abrir</Button> : null}
                  <IconButton size="small" title="Remover vínculo" onClick={() => detachLink(k.kind)}><DeleteIcon fontSize="small" /></IconButton>
                </Box>
              );
            })
          )}
        </Box>
        {!showLinkAdd ? (
          <Button size="small" startIcon={<AddIcon fontSize="small" />} onClick={() => setShowLinkAdd(true)}>Vincular ao CRM</Button>
        ) : (
          <>
            <Box display="flex" style={{ gap: 6 }} alignItems="center">
              <TextField select size="small" label="Tipo" value={addKind}
                onChange={(e) => { setAddKind(e.target.value); setResults([]); setTerm(""); }} style={{ minWidth: 140 }}>
                {LINK_KINDS.map((k) => <MenuItem key={k.kind} value={k.kind}>{k.icon} {k.label}</MenuItem>)}
              </TextField>
              <TextField size="small" fullWidth autoFocus placeholder={`Buscar ${linkKindMeta(addKind).label.toLowerCase()}...`}
                value={term} onChange={(e) => setTerm(e.target.value)} />
              <IconButton size="small" title="Fechar" onClick={() => { setShowLinkAdd(false); setTerm(""); setResults([]); }}><DeleteIcon fontSize="small" /></IconButton>
            </Box>
            {(searching || results.length > 0 || term.trim()) ? (
              <Paper variant="outlined" style={{ marginTop: 4, maxHeight: 180, overflowY: "auto" }}>
                {searching ? (
                  <Box p={1}><CircularProgress size={16} /></Box>
                ) : results.length > 0 ? (
                  results.map((r) => (
                    <Box key={r.id} p={1} style={{ cursor: "pointer", borderBottom: "1px solid rgba(0,0,0,0.06)" }} onClick={() => attachLink(addKind, r.id)}>
                      <Typography variant="body2" noWrap>{r.label}</Typography>
                      {r.sub ? <Typography variant="caption" color="textSecondary" noWrap style={{ display: "block" }}>{r.sub}</Typography> : null}
                    </Box>
                  ))
                ) : (
                  <Box p={1}><Typography variant="caption" color="textSecondary">Nada encontrado.</Typography></Box>
                )}
              </Paper>
            ) : null}
          </>
        )}

        <Divider style={{ margin: "14px 0 0" }} />
        {sectionLabel(SubjectIcon, "Comentários / atividade")}
        <Box display="flex" style={{ gap: 6 }}>
          <TextField size="small" placeholder="Escreva um comentário... (use @nome pra marcar)" value={comment} onChange={(e) => setComment(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") handleComment(); }} fullWidth />
          <Button size="small" onClick={handleComment}>Enviar</Button>
        </Box>
        <Box mt={1}>
          {activity.map((a) => (
            <Typography key={a.id} variant="body2" style={{ marginBottom: 2 }}>
              <b>{a.type === "comment" ? "💬" : "•"}</b> {a.body || a.type}
            </Typography>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDelete} style={{ color: "#c62828" }} startIcon={<DeleteIcon />}>Excluir</Button>
        <Button onClick={handleArchive} startIcon={<ArchiveIcon />}>Arquivar</Button>
        <Button onClick={handleDuplicate} startIcon={<FileCopyIcon />}>Duplicar</Button>
        <Box flexGrow={1} />
        <Button onClick={onClose} disabled={saving}>Fechar</Button>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={saving} startIcon={saving ? <CircularProgress size={16} /> : null}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CardModal;
